/** Gates the order entry modal's entrypoints: blotter New order, and marketplace and account holdings Buy and Sell. */
export const ENABLE_SIMPLIFIED_ORDER_ENTRY =
  'ff.trading.frontend_platform.simplified_order_entry'
